// Extracted so route head() JSON-LD can reference FAQ items without
// pulling the entire home-seo-sections module (and its components) into
// the initial homepage bundle.
//
// Accepts a translator function (e.g. from `translate()` or `useTranslation("marketing").t`)
// so FAQ questions/answers localise for the active locale.
export type FaqTranslator = (key: string, defaultText?: string) => string;

export function getFaqItems(t: FaqTranslator) {
  return [
    {
      q: t("faq.q1", "How do online trading card auctions work?"),
      a: t(
        "faq.a1",
        "Sellers list a card with a starting price, duration and optional Buy It Now. Registered buyers place bids in real time. When the timer ends, the highest bidder wins and pays securely through Stripe — the seller then ships the card, tracked, with full buyer protection.",
      ),
    },
    {
      q: t("faq.q2", "Can I sell Pokémon cards?"),
      a: t(
        "faq.a2",
        "Yes. Pokémon is our largest category. You can list raw cards or cards graded by PSA, BGS, CGC, SGC, ACE, PG or TAG — single lots or sealed products, from vintage Base Set to modern Scarlet & Violet.",
      ),
    },
    {
      q: t("faq.q3", "Can I sell One Piece cards?"),
      a: t(
        "faq.a3",
        "Yes. BidNova supports the full One Piece Card Game — from Romance Dawn and Paramount War onwards, including manga rares, alt arts and graded slabs.",
      ),
    },
    {
      q: t("faq.q4", "Can I auction Sports Cards?"),
      a: t(
        "faq.a4",
        "Yes. Football, basketball, baseball, F1, UFC and other sports cards are all supported — including Topps, Panini Prizm, Select, Donruss and Bowman.",
      ),
    },
    {
      q: t("faq.q5", "What grading companies are supported?"),
      a: t(
        "faq.a5",
        "BidNova accepts cards graded by PSA, BGS, CGC, SGC, ACE, PG and TAG. Certificate numbers are automatically verified for PSA, BGS, CGC and SGC; ACE, PG and TAG cards can be listed with manual entry.",
      ),
    },
    {
      q: t("faq.q6", "How are buyers protected?"),
      a: t(
        "faq.a6",
        "Every transaction runs through Stripe with 3-D Secure. Sellers are identity-verified, listings are moderated, and buyers can open a dispute for non-delivery, damage or misdescription and receive a refund under our buyer protection policy.",
      ),
    },
    {
      q: t("faq.q7", "What does it cost to sell on BidNova?"),
      a: t(
        "faq.a7",
        "BidNova charges a simple 8% commission on successful sales only. No monthly fees. No subscription fees. No listing fees.",
      ),
    },
  ];
}
